(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1ca6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1ca6"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $b4553a60b90dcb8b$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"7i0IA":"index.e2439bee.js","kGAUg":"Kyle Clapper Resume.f1edc59f.pdf","1Fnam":"hazmat.c0fc3b2f.jpeg","fwl10":"mics.0a1b7c97.jpg","aS2ey":"counter-screenshot.2bb44d5b.png","5sTOA":"badstats-screenshot.a5338a9a.png","ivVcD":"index.59f6ff97.css","5lcL9":"index.8ee5fe62.js","iSK7h":"index.29f8703c.js"}'));


var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aD5QK = parcelRequire("aD5QK");


var $iChgf = parcelRequire("iChgf");

var $aSiaI = parcelRequire("aSiaI");
function $e2758588e39ea44d$export$2e2bcd8739ae039({ bg: bg = "none", text: text = "black", children: children }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
        className: "rounded p-4 mt-3 bg-" + bg + " text-" + text,
        children: children
    });
}



var $aSiaI = parcelRequire("aSiaI");
function $2030e71197b1488e$export$2e2bcd8739ae039({ title: title, location: location, startDate: startDate, endDate: endDate, image: image, children: //imagePos='right',
children }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "pb-4",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "d-flex flex-wrap justify-content-between px-lg-4 pb-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "d-flex flex-column",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h6", {
                                className: "display-6",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("small", {
                                children: location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "mt-auto",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("small", {
                                children: [
                                    startDate,
                                    " "
                                ]
                            }),
                            endDate ? "-" : "",
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("small", {
                                children: [
                                    " ",
                                    endDate
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "clearfix border rounded p-lg-2",
                children: [
                    image ? /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: image,
                        className: "col-12 col-lg-6 float-lg-end mb-3 ms-lg-3 rounded"
                    }) : null,
                    children
                ]
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");
function $5f47e5e3c51aafd9$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("h5", {
                className: "display-5 text-center",
                children: children
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {})
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");
function $30d4bb465eed9c6e$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "container-lg px-4 px-lg-0 pt-4",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "row justify-content-center",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "col-lg-8",
                children: children
            })
        })
    });
}


var $5ea5d323e7ad47d0$exports = {};


$5ea5d323e7ad47d0$exports = (parcelRequire("aNJCr")).getBundleURL("7i0IA") + (parcelRequire("iE7OH")).resolve("kGAUg");


const $32180940764490c4$var$resume = new URL($5ea5d323e7ad47d0$exports);
var $bc48ca7ac4177a8a$exports = {};


$bc48ca7ac4177a8a$exports = (parcelRequire("aNJCr")).getBundleURL("7i0IA") + (parcelRequire("iE7OH")).resolve("1Fnam");


const $32180940764490c4$var$hazmat = new URL($bc48ca7ac4177a8a$exports);
var $c69d9cd6f9f2d9a0$exports = {};


$c69d9cd6f9f2d9a0$exports = (parcelRequire("aNJCr")).getBundleURL("7i0IA") + (parcelRequire("iE7OH")).resolve("fwl10");


const $32180940764490c4$var$mics = new URL($c69d9cd6f9f2d9a0$exports);
var $c6b6289014c08a73$exports = {};


$c6b6289014c08a73$exports = (parcelRequire("aNJCr")).getBundleURL("7i0IA") + (parcelRequire("iE7OH")).resolve("aS2ey");


const $32180940764490c4$var$counter = new URL($c6b6289014c08a73$exports);
var $dafbf2ae91700a28$exports = {};


$dafbf2ae91700a28$exports = (parcelRequire("aNJCr")).getBundleURL("7i0IA") + (parcelRequire("iE7OH")).resolve("5sTOA");


const $32180940764490c4$var$badstats = new URL($dafbf2ae91700a28$exports);
function $32180940764490c4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.StrictMode), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $iChgf.default), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $30d4bb465eed9c6e$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e2758588e39ea44d$export$2e2bcd8739ae039), {
                        bg: "secondary",
                        text: "light",
                        children: [
                            "For my CS210 students, I've posted the slides I use during discussion ",
                            /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: "/cs210",
                                children: "here."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("p", {
                        children: [
                            "My resume site has moved to ",
                            /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: "https://kyleclapper.dev",
                                children: "kyleclapper.dev"
                            }),
                            "head there to find my resume, cover letter, and blog."
                        ]
                    })
                ]
            })
        ]
    });
}
(0, $aD5QK.createRoot)(document.getElementById("app")).render(/*#__PURE__*/ (0, $aSiaI.jsx)($32180940764490c4$export$2e2bcd8739ae039, {}));

})();
//# sourceMappingURL=index.e2439bee.js.map
